import BaseService from "../base-service";
import NetworkUrls from "../network-urls";

class BookingService extends BaseService {

  async fetchHistory (accessToken, limit = 10, offset = 0, lang = 'FR') {
    const config = {
      url: NetworkUrls.graphql,
      method: 'POST',
      headers: {
        Authorization: accessToken,
      },
      data: {
        query: `query ($lang: Lang!,$limit: Int!, $offset: Int!) {
            Auth {
                bookings (limit: $limit, offset: $offset) {
                    id,
                    is_deleted,
                    is_refund,
                    is_insurance,
                    is_paid,
                    total_price,
                    total_refund,
                    payment_method,
                    payment_status,
                    booking_timestamp,
                    invoices {
                        number,
                        date,
                        price,
                        link
                    },
                    rooms {
                        room {
                            text (lang: $lang) {
                                short_name
                            }
                            main_picture {
                                absolute_path
                            },
                            provider
                        },
                        consos {
                          conso {
                            price,
                            text (lang: $lang) {
                                name
                            }
                          },
                          number,
                          custom_unit_price,
                          is_paid
                        },
                        extras {
                          extra {
                            price,
                            picture,
                            text (lang: $lang) {
                              name
                            }
                          },
                          dates {
                            date,
                            number
                          }
                          custom_unit_price,
                          is_paid
                        },
                        start,
                        end,
                        code,
                        nb_guest,
                        price,
                        mail,
                        phone,
                        is_insurance,
                        address {
                            address,
                            additional,
                            description,
                            city,
                            zip,
                            country {
                                alpha2
                            }
                        }
                    }
                }
            }
        }`,
        variables: {limit, offset, lang}
      }
    }
    return this._exec(config)
  }

  async fetchHistoryWidget (accessToken, limit = 10, offset = 0, lang = 'FR') {
    const config = {
      url: NetworkUrls.graphql,
      method: 'POST',
      headers: {
        Authorization: accessToken,
      },
      data: {
        query: `query ($lang: Lang!,$limit: Int!, $offset: Int!) {
                  Auth {
                      bookings (limit: $limit, offset: $offset) {
                          id,
                          is_deleted,
                          is_refund,
                          is_paid,
                          invoices {
                              number,
                              link
                          },
                          rooms {
                              id,
                              room {
                                  text (lang: $lang) {
                                      short_name
                                  }
                                  main_picture {
                                      absolute_path
                                  }
                              },
                              extras {
                                dates {
                                  number
                                }
                                is_paid
                              },
                              start,
                              end
                          }
                      }
                  }
              }`,
        variables: {limit, offset, lang}
      }
    }
    return this._exec(config)
  }

  async createBooking (accessToken, shoppingCard, data) {
    const config = {
      url: NetworkUrls.graphql,
      method: 'POST',
      headers: {
        Authorization: accessToken,
        'X-SC': shoppingCard,
      },
      data: {
        query: `mutation ($data: CreateBookingInput!) {
            Booking {
                create (data: $data) {
                    paymentIntent
                }
            }
        }`,
        variables: {
          data
        }
      }
    }
    return this._exec(config);
  }

}

export const bookingService = new BookingService();



// WEBPACK FOOTER //
// ./src/network/services/booking.service.js